export default "__VITE_ASSET__Dc_UZdcZ__"